import comp from "./Navbar";
export default comp;
